module.exports = __webpack_public_path__ + "1.5.0-unryo/img/license.65c25c44.svg";